import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass([
      _ctx.isOrderAsc
        ? 'fas fa-arrow-up text-primary'
        : 'fas fa-arrow-down text-primary'
    , "ms-2"])
  }, null, 2))
}